import { html } from 'lit-element'
import GDPRModule from './gdpr-module';
import LitElementBase from './lit/element-base';
import { Modal as BootstrapModal } from "bootstrap"

export default class ManageCookiesDialog extends LitElementBase {

    static get DomTag() { return  'manage-cookies-dialog'; }
    
    GetTranslations() {
		return {
			"NECESSARY": {
				"it": "Strettamente Necessari",
				"en": "Strictly Necessary",
            },
			"NECESSARY_description": {
				"it": "Questi cookie sono strettamente necessari per fornirti determinate funzionalità. Ad esempio, questi cookie ti consentono di accedere ad aree sicure che richiedono la registrazione e di impostare le tue preferenze sulla privacy. Poiché questi cookie sono essenziali per fornirti servizi, non possono essere disabilitati. Puoi impostare il tuo browser in modo che blocchi o ti avvisi di questi cookie, ma alcune parti del sito potrebbero non funzionare.",
				"en": "These cookies are strictly necessary to provide you with certain features. For example, these cookies allow you to access secure areas that require registration and set your privacy preferences. Because these cookies are essential to providing services to you, they cannot be disabled. You can set your browser to block or alert you about these cookies, but it may cause some parts of the site to not work.",
            },
			"PERFORMANCE": {
				"it": "Cookie di Performance",
				"en": "Performance Cookies",
            },
			"PERFORMANCE_description": {
				"it": "Questi cookie consentono a noi o ai nostri fornitori di analisi di terze parti di raccogliere informazioni e statistiche sull'utilizzo dei nostri servizi da parte tua e di altri visitatori. Queste informazioni ci aiutano a migliorare i nostri servizi e prodotti a vantaggio tuo e di altri.",
				"en": "These cookies allow us or our third-party analytics providers to collect information and statistics on use of our services by you and other visitors. This information helps us to improve our services and products for the benefit of you and others.",
            },
			"FUNCTIONAL": {
				"it": "Cookie di Funzionalità",
				"en": "Functional Cookies",
            },
			"FUNCTIONAL_description": {
				"it": "Questi cookie forniscono funzionalità avanzate, fornendo supporto chat, consentendoti di compilare moduli più facilmente, personalizzare i contenuti in base alle tue preferenze e selezionare le tue preferenze di comunicazione. Se non abiliti questi cookie o scegli di disabilitarli in futuro, ciò potrebbe influire sulla tua capacità di utilizzare determinate funzionalità.",
				"en": "These cookies provide enhanced functionality, providing chat support, allowing you to more easily complete forms, personalizing content to your preferences, and selecting your communications preferences. If you do not enable these cookies, or choose to disable them in the future, that could impact your ability to use certain features.",
            },
			"TARGETING": {
				"it": "Cookie di Targeting",
				"en": "Targeting Cookies",
			},
			"TARGETING_description": {
				"it": "Questi cookie, forniti dai nostri partner pubblicitari di terze parti, raccolgono informazioni sulle tue abitudini di navigazione, nonché le tue preferenze per varie funzionalità e servizi. Ci forniscono anche controlli, ricerche e rapporti per sapere quando il contenuto pubblicitario è stato visualizzato e quanto successo ha avuto il contenuto. Queste informazioni consentono a noi e ai nostri fornitori di pubblicità di terze parti di visualizzare contenuti pubblicitari pertinenti.",
				"en": "These cookies, provided by our third-party advertising partners, collect information about your browsing habits, as well as your preferences for various features and services. They also provide us with auditing, research, and reporting to know when advertising content has been displayed and how successful the content has been. This information allows us and our third-party advertising providers to display relevant advertising content.",
            },
			"Continue": {
				"it": "Continua",
				"en": "Continue",
            },
			"Privacy Preference Center": {
				"it": "Centro preferenze sulla privacy",
				"en": "Privacy Preference Center",
            },
			"When you visit any website, it may store or retrieve information on your browser, mostly in the form of cookies. This information might be about you, your preferences or your device and is mostly used to make the site work as you expect it to. The information does not usually directly identify you, but it can give you a more personalized web experience. Because we respect your right to privacy, you can choose not to allow some types of cookies. Click on the different category headings to find out more and change our default settings. However, blocking some types of cookies may impact your experience of the site and the services we are able to offer.": {
				"it": "Quando visiti un sito web, questo può memorizzare o recuperare informazioni sul tuo browser, principalmente sotto forma di cookie. Queste informazioni potrebbero riguardare te, le tue preferenze o il tuo dispositivo e vengono utilizzate principalmente per far funzionare il sito come ti aspetti. Le informazioni di solito non ti identificano direttamente, ma possono offrirti un'esperienza web più personalizzata. Poiché rispettiamo il tuo diritto alla privacy, puoi scegliere di non consentire alcuni tipi di cookie. Fare clic sui diversi titoli delle categorie per saperne di più e modificare le nostre impostazioni predefinite. Tuttavia, il blocco di alcuni tipi di cookie potrebbe influire sulla tua esperienza del sito e sui servizi che siamo in grado di offrire.",
				"en": "When you visit any website, it may store or retrieve information on your browser, mostly in the form of cookies. This information might be about you, your preferences or your device and is mostly used to make the site work as you expect it to. The information does not usually directly identify you, but it can give you a more personalized web experience. Because we respect your right to privacy, you can choose not to allow some types of cookies. Click on the different category headings to find out more and change our default settings. However, blocking some types of cookies may impact your experience of the site and the services we are able to offer.",
            },
			"Manage Consent Preferences": {
				"it": "Gestisci le preferenze di consenso",
				"en": "Manage Consent Preferences",
			},
			"More information": {
				"it": "Maggiori informazioni",
				"en": "More information"
			},
			"https://cookiepedia.co.uk/giving-consent-to-cookies": {
				"it": "https://it.wikipedia.org/wiki/Cookie",
				"en": "https://cookiepedia.co.uk/giving-consent-to-cookies"
			}
        }
    }
    
    static get properties() {
		return {}
	}

	constructor() {
		super();

		this.Data = {}
	}
	
	getData() {
		this.Data.AcceptLevel = 0;
		this.querySelectorAll("#CookiesPreferences input[type=checkbox]").forEach((el) => {
			if(el.checked && el.id && GDPRModule.ACCEPT_TYPES[el.id])
				this.Data.AcceptLevel += GDPRModule.ACCEPT_TYPES[el.id];
			});
		this.hideCallback(true)
		this.modal.hide()
	}

	PrintCheckboxes() {
		let htmlString = "";
		
		Object.keys(GDPRModule.ACCEPT_CATEGORIES).forEach((CATEGORY) => {
			htmlString += `
			<div class="gdpr-input-field">
				<div class="options cookie-details CookieDetails">
					<svg class="plus" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
						<path fill="#7B7B7B" d="M12,0A12,12,0,1,0,24,12,12.035,12.035,0,0,0,12,0Zm6,13H13v5H11V13H6V11h5V6h2v5h5Z"/>
					</svg>
					<svg class="minus" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
						<path fill="#7B7B7B" d="M12,0A12,12,0,1,0,24,12,12.035,12.035,0,0,0,12,0Zm6,13H6V11H18Z"/>
					</svg>
					<div>
						<div class="accordion">
							${this.Ln(CATEGORY)}
						</div>
						<input`;
						if(CATEGORY == GDPRModule.ACCEPT_CATEGORIES.NECESSARY)
							htmlString += ` checked disabled`;
						htmlString += ` type="checkbox" id="${CATEGORY}">
						<label for="${CATEGORY}" title="${this.Ln(CATEGORY)}"></label>
						<p class="cookie-description">${this.Ln(CATEGORY+"_description")}</p>
					</div>
				</div>
			</div>
			`;
		})
		return htmlString;
	}

    render(){
		return html`
			<div class="Modal modal" tabindex="-1" data-bs-backdrop="static">
				<div class="modal-dialog modal-dialog-centered modal-lg">
					<div class="modal-content">
						<div class="modal-header">
							<button type="button" class="btn-close" @click="${() => {this.CloseDialog()}}" aria-label="Close"></button>
						</div>
						<div class="modal-body">
							<div>
								<h2>${this.Ln("Privacy Preference Center")}</h2>
								<p>${this.Ln("When you visit any website, it may store or retrieve information on your browser, mostly in the form of cookies. This information might be about you, your preferences or your device and is mostly used to make the site work as you expect it to. The information does not usually directly identify you, but it can give you a more personalized web experience. Because we respect your right to privacy, you can choose not to allow some types of cookies. Click on the different category headings to find out more and change our default settings. However, blocking some types of cookies may impact your experience of the site and the services we are able to offer.")}</p>
								<p>
									<a class="link-dark" target="_blank" href="${this.Ln("https://cookiepedia.co.uk/giving-consent-to-cookies")}">${this.Ln("More information")}</a>
								</p>
								<h2>${this.Ln("Manage Consent Preferences")}</h2>
								<div id="CookiesPreferences">
									${this.ToHtml(this.PrintCheckboxes())}
								</div>
							</div>
						</div>
						<div class="modal-footer">
							<button @click="${() => {this.getData()}}" type="button" class="btn btn-primary">${this.Ln("Continue")}</button>
						</div>
					</div>
				</div>
			</div>`;
	}

	firstUpdated() {
        super.firstUpdated()

		const modalEl = this.querySelector('.Modal')
		this.modal = new BootstrapModal(modalEl)
        this.modal.show()
        modalEl.addEventListener("hidden.bs.modal", () => {
            this.remove()
        })

		this.querySelectorAll(".CookieDetails > svg").forEach((el)=> {
			el.addEventListener("click", (e) => {
				this.ToggleAccordion(el.parentNode);
			})
		})
		this.querySelectorAll(".CookieDetails .accordion").forEach((el)=> {
			el.addEventListener("click", (e) => {
				this.ToggleAccordion(el.parentNode.parentNode);
			})
		})
	}
    
    CloseDialog() {
        this.hideCallback(false)
        this.modal.hide()
    }
	
    OnHide(callback) {
        this.hideCallback = callback
    }

	ToggleAccordion(el) {
		this.querySelectorAll(".CookieDetails.is-open").forEach((elOpen)=> {
			if(elOpen != el)
				elOpen.classList.remove("is-open")
		})
		el.classList.toggle('is-open')
	}
}

ManageCookiesDialog.RegisterElement()